/* eslint-disable react-hooks/exhaustive-deps */
import TableBtn from "components/fragments/TableBtn";
import TableCountDisplay from "components/fragments/TableCountDisplay";
import TableOpenBtn from "components/fragments/TableOpenBtn";
import TableZoneBtn from "components/fragments/TableZoneBtn";
import ModalTableOpenConfirm from "components/modals/ModalTableOpenConfirm";
import TableCard from "components/modals/TableCard";
import React, { useEffect, useRef, useState } from "react";
import FormTableReserved from "components/modals/FormTableReserved";
import TableOnModeActive from "components/modals/TableOnModeActive";
import FormTableMerge from "components/modals/FormTableMerge";
import ModalTableEventMode from "components/modals/ModalTableEventMode";
import FormTableMove from "components/modals/FormTableMove";
import { useNavigate, useLocation } from "react-router-dom";
import ShowTableDetail from "components/modals/ShowTableDetail";
import ModalQrTablePrint from "components/modals/printing-forms/ModalQrTablePrint";
import { createQrSession } from "services/qrSession.service";
import { tableHandler, billHandler, posHandler } from "../../redux/handlers";
import * as billSlice from "../../redux/slices/bill.slice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  setPendingTableOrder,
  setOrderId,
  resetCurrentOrder,
} from "../../redux/slices/pos.slice";

export default function TablePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { businessSlug } = useParams();
  const currentBranchId = localStorage.getItem("branchId");

  const tableData = useSelector((state) => state.table?.data);
  const tableZone = useSelector((state) => state.table?.zone);
  const posBranchInfo = useSelector((state) => state.pos?.branch);

  const [tableZoneBtnList, setTableZoneBtnList] = useState([]);
  const [tableZoneSelected, setTableZoneSelected] = useState(0);
  const [currentZone, setCurrentZone] = useState(0);
  const [tableCardList, setTableCardList] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [tableSeletected, setTableSeletected] = useState();
  const [persistentSelectedTable, setPersistentSelectedTable] = useState(null);
  const [modalTableOpenCfOpen, setModalTableOpenCfOpen] = useState(false);
  const [modalTableMergeCancelOpen, setModalTableMergeCancelOpen] =
    useState(false);
  const [modalTableMergeCfOpen, setModalTableMergeCfOpen] = useState(false);
  const [isReservedMode, setIsReservedMode] = useState(false);
  const [isMergeTableMode, setIsMergeTableMode] = useState(false);
  const [tableMergeSelectedList, setTableMergeSelectedList] = useState([]);
  const [isMoveMode, setIsMoveMode] = useState(false);
  const [tableMoveSelected, setTableMoveSelected] = useState();
  const [modalTableMoveCancelOpen, setModalTableMoveCancelOpen] =
    useState(false);
  const [modalTableMoveCfOpen, setModalTableMoveCfOpen] = useState(false);
  const [isDetailMode, setIsDetailMode] = useState(false);
  const wasDetailOpenRef = useRef(false); // [system] track if detail modal was ever opened
  const [modalQrPrintOpen, setModalQrPrintOpen] = useState(false);
  const [qrPrintTables, setQrPrintTables] = useState([]);
  const [qrDynamic, setQrDynamic] = useState(null); // { tableId, tableName, qrToken, qrUrl, expiresAt }
  const [qrDynamicLoading, setQrDynamicLoading] = useState(false);
  const [closingTable, setClosingTable] = useState(false); // [close-table]
  const [closeTableDone, setCloseTableDone] = useState(false); // [close-table] brief success flash
  const [selectedTableHasOrders, setSelectedTableHasOrders] = useState(false); // [close-table] disable when orders exist

  const [tableSeatInfo, setTableSeatInfo] = useState({
    total_seat: 0,
    table_in_use: 0,
  });

  const updateZone = (index, id) => {
    setTableZoneSelected(index);
    setCurrentZone(id);

    dispatch(tableHandler.getAllTableData(businessSlug, id));
  };

  const fetchTableSeatInfo = async () => {
    try {
      const data = await dispatch(tableHandler.getTableSeatInfo(businessSlug));
      if (data) {
        setTableSeatInfo({
          total_seat: data.total_seat || 0,
          table_in_use: data.table_in_use || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching table seat info:", error);
    }
  };

  const getTableIdBySelected = (selectedTableId) => {
    return selectedTableId;
  };

  const getTableDataById = (tableId) => {
    if (tableId === tableSeletected && persistentSelectedTable) {
      return persistentSelectedTable;
    }

    const foundTable = tableCardList.find((table) => table.tableID === tableId);
    return (
      foundTable ||
      (tableId === tableSeletected ? persistentSelectedTable : null)
    );
  };

  const selectTable = (tableId) => {
    const selectedTableData = tableCardList.find(
      (table) => table.tableID === tableId
    );
    setTableSeletected(tableId);
    setPersistentSelectedTable(selectedTableData);
  };

  const clearTableSelection = () => {
    setTableSeletected(undefined);
    setPersistentSelectedTable(null);
  };

  const formatTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const calculateEndTime = (openedAt, timeDurationMinutes) => {
    try {
      const openedDate = new Date(openedAt);
      if (isNaN(openedDate.getTime())) {
        console.error("Invalid opened_at date:", openedAt);
        return "";
      }
      const endDate = new Date(
        openedDate.getTime() + timeDurationMinutes * 60 * 1000
      );
      return endDate.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch (error) {
      console.error("Error calculating end time:", error);
      return "";
    }
  };

  const isTableOvertime = (openedAt, timeDurationMinutes) => {
    try {
      if (!openedAt || !timeDurationMinutes) return false;

      const openedDate = new Date(openedAt);
      const endDate = new Date(
        openedDate.getTime() + timeDurationMinutes * 60 * 1000
      );
      const currentTime = new Date();

      return currentTime > endDate;
    } catch (error) {
      console.error("Error checking overtime:", error);
      return false;
    }
  };

  function formatDateTime(value) {
    let result = Number(Number(value.hour) * 60 + Number(value.min));
    return result;
  }

  const reservedTable = async (values) => {
    await dispatch(tableHandler.setReserved(businessSlug, values));
    await new Promise((resolve) => setTimeout(resolve, 200));
    await dispatch(tableHandler.getAllTableData(businessSlug, currentZone));

    await fetchTableSeatInfo();
    clearTableSelection();
    setRefreshTrigger((prev) => prev + 1);
  };

  const openTable = async (values) => {
    const advanceMinutes = formatDateTime(values.time);

    const selectedTable = getTableDataById(tableSeletected);

    let formatData = {
      branch_table_id: getTableIdBySelected(tableSeletected),
      seat: values.person,
      time_duration: values.isSetTime ? advanceMinutes : 0,
    };

    await dispatch(tableHandler.setTableInUse(businessSlug, formatData));
    await new Promise((resolve) => setTimeout(resolve, 300));
    await dispatch(tableHandler.getAllTableData(businessSlug, currentZone));

    await fetchTableSeatInfo();

    // [qr] Auto-print dynamic QR after opening table — skipped if branch has is_qr_order disabled
    const isQrOrderEnabled = posBranchInfo?.branch_info?.is_qr_order !== false;
    if (selectedTable && isQrOrderEnabled) {
      try {
        // [fix] clear stale bill from Redux before showing QR — ModalQrTablePrint reads state.bill.data
        dispatch(billSlice.clearBill());
        const qrExpiry = values.isSetTime ? advanceMinutes : undefined;
        const session = await createQrSession(businessSlug, selectedTable.tableID, qrExpiry);
        setQrDynamic({
          tableId: selectedTable.tableID,
          tableName: selectedTable.tableNo,
          qrToken: session.qrToken,
          qrUrl: session.qrUrl,
          expiresAt: session.expiresAt,
        });
      } catch (err) {
        console.error("[qr] auto-print QR after open table failed:", err);
      }
    }

    clearTableSelection();
    setRefreshTrigger((prev) => prev + 1);
  };

  const handlePrintQr = async () => {
    const selectedTable = getTableDataById(tableSeletected);
    if (!selectedTable) return;
    const isInUse = selectedTable.type === "using" || selectedTable.type === "overtime";
    if (isInUse) {
      // [qr] In-use table → dynamic session QR (thermal bill format)
      try {
        setQrDynamicLoading(true);
        // [qr] Get bill list first to find billId, then load full bill into state.bill.data
        const tableBills = await dispatch(billHandler.getBillByBranchTableId(businessSlug, selectedTable.tableID));
        const billId = Array.isArray(tableBills) && tableBills.length > 0 ? tableBills[0].id : null;

        // [qr] compute remaining minutes so QR expires when table session ends (not a fresh 8h window)
        let remainingMinutes;
        if (selectedTable.time_duration && selectedTable.opened_at) {
          const elapsedMs = Date.now() - new Date(selectedTable.opened_at).getTime();
          const elapsedMin = Math.floor(elapsedMs / 60000);
          const left = selectedTable.time_duration - elapsedMin;
          remainingMinutes = left > 1 ? left : 1; // minimum 1 minute
        }
        const [session] = await Promise.allSettled([
          createQrSession(businessSlug, selectedTable.tableID, remainingMinutes),
          billId ? dispatch(billHandler.getBillById(businessSlug, billId)) : Promise.resolve(null),
        ]);

        if (session.status === "rejected") throw session.reason;

        const sessionData = session.value;
        setQrDynamic({
          tableId: selectedTable.tableID,
          tableName: selectedTable.tableNo,
          qrToken: sessionData.qrToken,
          qrUrl: sessionData.qrUrl,
          expiresAt: sessionData.expiresAt,
        });
      } catch (err) {
        console.error("[qr] handlePrintQr failed:", err);
        alert(err?.message || "ไม่สามารถสร้าง QR session ได้");
      } finally {
        setQrDynamicLoading(false);
      }
    } else {
      // [qr] Vacant/reserved → receipt format static QR
      setQrPrintTables([{ tableId: selectedTable.tableID, tableName: selectedTable.tableNo }]);
      setModalQrPrintOpen(true);
    }
  };

  const handlePrintQrAll = () => {
    if (!tableCardList || tableCardList.length === 0) return;
    const tables = tableCardList.map((t) => ({ tableId: t.tableID, tableName: t.tableNo }));
    setQrPrintTables(tables);
    setModalQrPrintOpen(true);
  };

  const moveTable = async () => {
    const currentTable = getTableDataById(tableSeletected);
    const form = {
      from_table_id: currentTable?.tableID,
      to_table_id: tableMoveSelected?.tableID,
    };
    await dispatch(tableHandler.setMove(businessSlug, form));
    await new Promise((resolve) => setTimeout(resolve, 200));
    await dispatch(tableHandler.getAllTableData(businessSlug, currentZone));
    await fetchTableSeatInfo();
    clearTableSelection();
    setRefreshTrigger((prev) => prev + 1);
  };

  const mergeTable = async () => {
    const currentTable = getTableDataById(tableSeletected);
    let targetTableIds = [];

    tableMergeSelectedList.forEach((table) => {
      targetTableIds.push(table.tableID);
    });

    const form = {
      primary_table_id: currentTable?.tableID,
      merged_table_ids: targetTableIds,
    };

    await dispatch(tableHandler.setMerge(businessSlug, form));
    await new Promise((resolve) => setTimeout(resolve, 200));
    await dispatch(tableHandler.getAllTableData(businessSlug, currentZone));

    await fetchTableSeatInfo();
    clearTableSelection();
    setRefreshTrigger((prev) => prev + 1);
    setTableMergeSelectedList([]);
    setIsMergeTableMode(false);
    setModalTableMergeCfOpen(false);
  };

  // [close-table] Clear occupied table with no orders — deactivates QR sessions server-side
  const handleCloseTable = async () => {
    if (!tableSeletected || closingTable || closeTableDone) return;
    setClosingTable(true);
    try {
      await dispatch(tableHandler.clearTable(businessSlug, tableSeletected));
      // [close-table] Optimistic update — mark table as empty immediately so UI reflects change without reload
      setTableCardList((prev) =>
        prev.map((t) =>
          t.tableID === tableSeletected
            ? { ...t, type: 'empty', table_status: 'AVALIABLE', seat: null, time_duration: null, opened_at: null }
            : t
        )
      );
      // [close-table] Show success flash for 1.2s so user sees confirmation before panel closes
      setClosingTable(false);
      setCloseTableDone(true);
      await new Promise((resolve) => setTimeout(resolve, 1200));
      clearTableSelection();
      setCloseTableDone(false);
      // [close-table] Sync fresh data from server in background
      await dispatch(tableHandler.getAllTableData(businessSlug, currentZone));
      await fetchTableSeatInfo();
      setRefreshTrigger((prev) => prev + 1);
    } catch (error) {
      console.error('[close-table] error:', error);
      setClosingTable(false);
    }
  };

  const handleOrderFromTable = async () => {
    const selectedTable = getTableDataById(tableSeletected);

    if (!selectedTable) return;

    try {
      dispatch(setOrderId(null));
      dispatch(resetCurrentOrder());

      const existingBillResponse = await dispatch(
        billHandler.getBillByBranchTableId(businessSlug, selectedTable.tableID)
      );

      if (existingBillResponse && existingBillResponse.length > 0) {
        const billInfo = existingBillResponse[0];
        if (billInfo.order_id) {
          dispatch(setOrderId(billInfo.order_id));
          navigate(`/${businessSlug}`);
          return;
        }
      }
    } catch (error) {
      console.error("Error checking existing bill:", error);
    }

    const tableOrderData = {
      tableID: selectedTable.tableID,
      tableNo: selectedTable.tableNo,
      zoneID: currentZone,
      delivery: 1,
      orderType: "DINE_IN",
    };

    dispatch(setPendingTableOrder(tableOrderData));
    navigate(`/${businessSlug}`);
  };

  const canMoveTable = (tableData) => {
    if (!tableData) return false;
    return (
      tableData.type !== "empty" &&
      tableData.type !== "reserved" &&
      tableData.type !== "overtime" &&
      !tableData.mergeList &&
      !tableData.mainTable?.length
    );
  };

  const canMergeTable = (tableData) => {
    if (!tableData) return false;
    return (
      tableData.type !== "empty" &&
      tableData.type !== "reserved" &&
      tableData.type !== "overtime" &&
      !tableData.mergeList &&
      !tableData.moveFrom
    );
  };

  const canOrderFood = (tableData) => {
    if (!tableData) return false;
    return tableData.type !== "empty" && tableData.type !== "reserved";
  };

  useEffect(() => {
    const updatedTableList = tableData?.map((item) => {
      const hasCustomers = item?.customerTable?.[0] != null;
      const hasReservation = item?.table_reservations?.[0] != null;
      const hasMove = item?.tableMove?.[0] != null;
      const hasMerge = item?.tableMerge?.[0] != null;

      const isOvertime =
        item.table_status === "IN_USE" && item?.opened_at && item?.time_duration
          ? isTableOvertime(item.opened_at, item.time_duration)
          : false;

      let type = "empty";
      if (hasReservation) {
        type = "reserved";
      } else if (item.table_status === "AVALIABLE") {
        type = "empty";
      } else if (item.table_status === "IN_USE") {
        type = isOvertime ? "overtime" : "using";
      } else {
        type = "using";
      }

      const maxPerson = item?.seat_capacity == null ? 0 : item?.seat_capacity;
      const currentPerson = hasReservation
        ? item?.table_reservations[0].total_guest
        : 0;
      const currentSeat = item.table_status === "IN_USE" ? item?.seat || 0 : 0;
      const time = hasReservation
        ? formatTime(item?.table_reservations[0].reservation_time)
        : item?.table_status === "IN_USE"
        ? formatTime(item?.opened_at)
        : "00:00 AM" || "00:00 AM";
      const moveFrom =
        item?.moved_from_tables[0] != null
          ? item?.moved_from_tables[0]?.table_name
          : "";
      const mergeList =
        item?.primary_table_merges[0] == null
          ? ""
          : item?.primary_table_merges[0].table_name;
      const customerTableId = hasMove
        ? item?.tableMove[0]?.customerTable.id
        : hasMerge
        ? item?.tableMerge[0]?.customerTable.id
        : hasCustomers
        ? item?.customerTable[0].id
        : 0;

      const customerName = hasReservation
        ? item?.table_reservations[0]?.customer_name
        : "";
      const createdTime = hasReservation
        ? formatTime(item?.table_reservations[0]?.created_at)
        : "";
      const reservationTime = hasReservation
        ? formatTime(item?.table_reservations[0]?.reservation_time)
        : "";

      const openedTime =
        item.table_status === "IN_USE" && item?.opened_at
          ? formatTime(item.opened_at)
          : "";
      const endTime =
        item.table_status === "IN_USE" && item?.opened_at && item?.time_duration
          ? calculateEndTime(item.opened_at, item.time_duration)
          : "";

      let mainTableList = [];
      if (item?.merged_tables[0] != null) {
        item?.merged_tables.forEach((item) => {
          mainTableList.push(item.table_name);
        });
      }

      return {
        tableNo: item?.table_name,
        tableID: item?.table_id,
        maxPerson,
        time,
        timeUp: "",
        remark: "",
        type,
        mergeList: mergeList,
        moveFrom: moveFrom,
        currentPerson,
        currentSeat,
        customer_table_id: customerTableId,
        mainTable: mainTableList,
        customerName: customerName,
        createdTime: createdTime,
        reservationTime: reservationTime,
        openedTime: openedTime,
        endTime: endTime,
        ...item,
      };
    });
    setTableCardList(updatedTableList);
  }, [tableData, refreshTrigger]);

  // [system] auto-open table detail when navigated from call-staff BILL notification
  // [fix] store last-opened tableId (not boolean) so multiple calls to same/different table all work
  const callBillAutoOpenedRef = useRef(null);
  const callBillTableId = location.state?.callBillTableId;
  useEffect(() => {
    if (!callBillTableId || tableCardList.length === 0) return;
    if (callBillAutoOpenedRef.current === String(callBillTableId)) return;
    const match = tableCardList.find((t) => String(t.tableID) === String(callBillTableId));
    if (match) {
      callBillAutoOpenedRef.current = String(callBillTableId);
      selectTable(match.tableID);
      setIsDetailMode(true);
    }
  }, [tableCardList, callBillTableId]);

  useEffect(() => {
    dispatch(tableHandler.getAllTableZone(businessSlug, currentBranchId));
    fetchTableSeatInfo();
    // [qr] Load branch info so DynamicReceiptPrint can read business name + logo
    if (currentBranchId) {
      dispatch(posHandler.getBranchInfo(businessSlug, currentBranchId));
    }
  }, [dispatch]);

  useEffect(() => {
    if (tableZone && tableZone?.length > 0) {
      let temp = [];
      tableZone?.forEach((item) => {
        temp.push({
          id: item?.id,
          name: item?.name,
        });
      });
      dispatch(tableHandler.getAllTableData(businessSlug, temp[0]?.id));
      setTableZoneBtnList(temp);
      setCurrentZone(temp[0]?.id);
      setTableZoneSelected(0);
    }
  }, [tableZone]);

  useEffect(() => {
    fetchTableSeatInfo();
  }, [refreshTrigger, currentZone]);

  // [system] re-fetch table data when ShowTableDetail modal closes — payment may have released the table
  useEffect(() => {
    if (isDetailMode) {
      wasDetailOpenRef.current = true;
    } else if (wasDetailOpenRef.current) {
      wasDetailOpenRef.current = false;
      dispatch(tableHandler.getAllTableData(businessSlug, currentZone));
      fetchTableSeatInfo();
    }
  }, [isDetailMode]);

  // [close-table] check if selected table has pending orders — disable ปิดโต๊ะ when orders exist
  useEffect(() => {
    if (!tableSeletected) {
      setSelectedTableHasOrders(false);
      return;
    }
    const tData = getTableDataById(tableSeletected);
    if (!tData || !['using', 'overtime'].includes(tData.type)) {
      setSelectedTableHasOrders(false);
      return;
    }
    dispatch(billHandler.getBillByBranchTableId(businessSlug, tableSeletected))
      .then((response) => {
        const hasOrders = Array.isArray(response) && response.length > 0 &&
          response[0].billItems?.length > 0;
        setSelectedTableHasOrders(!!hasOrders);
      })
      .catch(() => setSelectedTableHasOrders(false));
  }, [tableSeletected, isDetailMode]);

  return (
    <div className="">
      <div className="flex items-center justify-between bg-[#FFF] pl-[min(2.34vw,24px)] py-[min(0.59vw,6px)] pr-[min(4.00vw,41px)]">
        <div className="flex">
          <TableCountDisplay
            info={{
              headTxt: "จำนวนโต๊ะใช้งาน",
              iconClassColor: "bg-[var(--color-green)]",
              iconPath: "/img/icons/icon-table-display.svg",
              countTxt: tableSeatInfo.table_in_use,
            }}
          />
          <TableCountDisplay
            info={{
              headTxt: "จำนวนลูกค้าในร้าน",
              iconClassColor: "bg-[#FF731D]",
              iconPath: "/img/icons/icon-customer-display.svg",
              countTxt: tableSeatInfo.total_seat,
            }}
          />
        </div>
        <div className="flex items-center gap-[min(0.78vw,8px)] pr-[min(0.98vw,10px)]">
          <div className="text-10 whitespace-nowrap">โต๊ะที่เลือก</div>
          <div className="h-[min(4.88vw,50px)] min-w-[min(4.79vw,49px)] bg-[#2dc76d26] flex items-center justify-center rounded-[min(0.29vw,3px)]">
            <div className="text-20 font-[700] text-[var(--color-green)]">
              {tableSeletected !== undefined
                ? getTableDataById(tableSeletected)?.tableNo
                : "-"}
            </div>
          </div>
        </div>
        <div className="flex gap-[min(0.98vw,10px)]">
          <TableBtn
            onClick={() => setIsMergeTableMode(true)}
            className="flex justify-center items-center btn-orange shadow-table-btn-2 text-14"
            content={<div className="">รวมโต๊ะ</div>}
            isActive={
              tableSeletected !== undefined &&
              canMergeTable(getTableDataById(tableSeletected)) &&
              !isMoveMode
            }
          />

          <TableBtn
            onClick={() => setIsMoveMode(true)}
            className="flex justify-center items-center btn-orange shadow-table-btn-2 text-14"
            content={<div className="">ย้ายโต๊ะ</div>}
            isActive={
              tableSeletected !== undefined &&
              canMoveTable(getTableDataById(tableSeletected)) &&
              !isMergeTableMode
            }
          />

          <TableBtn
            onClick={handleOrderFromTable}
            className="flex justify-center items-center btn-main-active shadow-table-btn-2 text-14"
            content={<div className="">สั่งอาหาร</div>}
            isActive={
              tableSeletected !== undefined &&
              canOrderFood(getTableDataById(tableSeletected)) &&
              !isMergeTableMode &&
              !isMoveMode
            }
          />

          <TableBtn
            onClick={() => setIsDetailMode(true)}
            className="flex justify-center items-center btn-blue-2 shadow-table-btn-2 text-14"
            content={<div className="">ดูรายการ</div>}
            isActive={
              tableSeletected !== undefined &&
              canOrderFood(getTableDataById(tableSeletected)) &&
              !isMergeTableMode &&
              !isMoveMode
            }
          />

          <TableBtn
            onClick={handlePrintQr}
            className="flex justify-center items-center btn-purple shadow-table-btn-2 text-14"
            content={<div className="">{qrDynamicLoading ? "..." : "Print QR"}</div>}
            isActive={
              tableSeletected !== undefined &&
              (getTableDataById(tableSeletected)?.type === "using" ||
                getTableDataById(tableSeletected)?.type === "overtime") &&
              !isMergeTableMode &&
              !isMoveMode
            }
          />

        </div>
      </div>

      <div className="pr-[min(4.00vw,41px)]">
        {isReservedMode && (
          <FormTableReserved
            isReservedModeObj={{
              isMode: isReservedMode,
              isSetMode: setIsReservedMode,
            }}
            onSubmit={reservedTable}
            table={getTableDataById(tableSeletected)}
          />
        )}
        {isMergeTableMode && (
          <FormTableMerge
            tableMergeSelectedListObj={{
              tableMergeSelectedList: tableMergeSelectedList,
              setTableMergeSelectedList: setTableMergeSelectedList,
            }}
            tableSeletected={tableSeletected}
            persistentSelectedTable={persistentSelectedTable}
            tableCardList={tableCardList}
            onConfirm={() => setModalTableMergeCfOpen(true)}
            onCancel={() => setModalTableMergeCancelOpen(true)}
          />
        )}
        {isMoveMode && (
          <FormTableMove
            tableSeletected={tableSeletected}
            tableMoveSelectedObj={{
              selected: tableMoveSelected,
              setSelected: setTableMoveSelected,
            }}
            tableCardList={tableCardList}
            persistentSelectedTable={persistentSelectedTable}
            onConfirm={() => {
              setModalTableMoveCfOpen(true);
            }}
            onCancel={() => setModalTableMoveCancelOpen(true)}
          />
        )}
        {!isReservedMode && (
          <div className="flex pl-[min(5.76vw,59px)] pt-[min(1.86vw,19px)] pb-[min(1.56vw,16px)]">
            <div className="w-full flex justify-between pr-[min(2.15vw,22px)]">
              <div className="flex gap-[min(1.17vw,12px)]">
                {tableZoneBtnList.map((value, index) => {
                  return (
                    <TableZoneBtn
                      key={index}
                      onClick={() => updateZone(index, value?.id)}
                      btnTxt={value?.name}
                      isActive={index === tableZoneSelected}
                    />
                  );
                })}
              </div>
              {!isMergeTableMode && (
                <div className="flex gap-[min(1.37vw,14px)]">
                  <TableOpenBtn
                    onClick={() => setModalTableOpenCfOpen(true)}
                    className={"btn-main-active"}
                    btnTxt={"เปิดโต๊ะ"}
                    isActive={
                      tableSeletected !== undefined &&
                      ["empty", "reserved"].includes(
                        getTableDataById(tableSeletected)?.type
                      )
                    }
                  />
                  <TableOpenBtn
                    onClick={() => setIsReservedMode(true)}
                    className={"btn-yellow"}
                    btnTxt={"จองโต๊ะ"}
                    isActive={
                      tableSeletected !== undefined &&
                      getTableDataById(tableSeletected)?.type === "empty"
                    }
                  />
                  {/* [close-table] Close table button — disabled when orders exist or loading */}
                  <TableOpenBtn
                    onClick={!closingTable && !closeTableDone && !selectedTableHasOrders ? handleCloseTable : undefined}
                    className={closeTableDone ? "!bg-green-500 !text-white" : "!bg-red-500 !text-white hover:!bg-red-600"}
                    btnTxt={closingTable ? "กำลังปิด..." : closeTableDone ? "ปิดโต๊ะสำเร็จ" : "ปิดโต๊ะ"}
                    title={selectedTableHasOrders ? "มีรายการค้างอยู่ กรุณาเช็คบิลก่อน" : undefined}
                    isActive={
                      (!closingTable || closeTableDone) &&
                      !selectedTableHasOrders &&
                      tableSeletected !== undefined &&
                      (closeTableDone || ["using", "overtime"].includes(
                        getTableDataById(tableSeletected)?.type
                      ))
                    }
                  />
                </div>
              )}
            </div>
          </div>
        )}

        <div className="flex pl-[min(2.44vw,25px)]">
          <div className="bg-[#FFF] rounded-[min(1.46vw,15px)] py-[min(2.93vw,30px)] pr-[min(4.39vw,45px)] w-full max-h-[68.75vh] overflow-auto">
            {!isReservedMode && !isMergeTableMode && !isMoveMode && (
              <div className="flex justify-end gap-[min(0.98vw,10px)] text-16">
                <div className="flex items-baseline gap-[min(0.49vw,5px)]">
                  <div className="aspect-square h-fit w-[min(1.76vw,18px)] bg-[#F4F4F4] border-[#b6bbc6] border-[min(0.10vw,1px)] rounded-full"></div>
                  <div className="font-[300] text-[var(--color-grey-2)]">
                    ว่าง
                  </div>
                </div>
                <div className="flex items-baseline gap-[min(0.49vw,5px)]">
                  <div className="aspect-square h-fit w-[min(1.76vw,18px)] bg-[var(--color-yellow)] rounded-full"></div>
                  <div className="font-[300] text-[var(--color-grey-2)]">
                    จอง
                  </div>
                </div>
                <div className="flex items-baseline gap-[min(0.49vw,5px)]">
                  <div className="aspect-square h-fit w-[min(1.76vw,18px)] bg-[var(--color-green)] rounded-full"></div>
                  <div className="font-[300] text-[var(--color-grey-2)]">
                    ไม่ว่าง
                  </div>
                </div>
                <div className="flex items-center gap-[min(0.49vw,5px)]">
                  <div className="aspect-square h-fit w-[min(1.76vw,18px)] bg-[var(--color-red)] rounded-full"></div>
                  <div className="font-[300] text-[var(--color-grey-2)]">
                    เกินเวลา
                  </div>
                </div>
              </div>
            )}
            {isReservedMode && (
              <TableOnModeActive
                info={{
                  headText: "กรุณาเลือกโต๊ะที่ต้องการจอง",
                  disabledText: "ไม่สามารถจองได้",
                  activeText: "จองได้",
                }}
              />
            )}
            {isMergeTableMode && (
              <TableOnModeActive
                info={{
                  headText: "กรุณาเลือกโต๊ะที่ต้องการรวม",
                  disabledText: "ไม่สามารถรวมได้",
                  activeText: "รวมได้",
                }}
              />
            )}
            {isMoveMode && (
              <TableOnModeActive
                info={{
                  headText: "กรุณาเลือกโต๊ะที่ต้องการย้าย",
                  disabledText: "ไม่สามารถย้ายได้",
                  activeText: "ย้ายได้",
                }}
              />
            )}
            <div className="grid grid-cols-6 xl:grid-cols-8 2xl:grid-cols-10 gap-[min(3.13vw,32px)] pl-[min(2.83vw,29px)] py-[min(1.86vw,19px)]">
              {tableCardList.map((value, index) => {
                return (
                  <TableCard
                    onClick={() => {
                      if (!isMergeTableMode && !isMoveMode) {
                        return selectTable(value.tableID);
                      }
                      if (
                        isMergeTableMode &&
                        value.tableID !== tableSeletected
                      ) {
                        const isSelected = tableMergeSelectedList.some(
                          (table) => table.tableID === value.tableID
                        );
                        return setTableMergeSelectedList((prevArray) =>
                          isSelected
                            ? prevArray.filter(
                                (table) => table.tableID !== value.tableID
                              )
                            : [...prevArray, value]
                        );
                      }
                      if (isMoveMode && value.tableID !== tableSeletected) {
                        if (value.tableID === tableMoveSelected) {
                          return setTableMoveSelected(undefined);
                        }
                        return setTableMoveSelected(value);
                      }
                    }}
                    key={index}
                    info={{
                      currentPerson: value.currentPerson,
                      currentSeat: value.currentSeat,
                      maxPerson: value.maxPerson,
                      time: value?.time,
                      timeUp: value?.timeUp,
                      remark: value?.remark,
                      tableNo: value?.tableNo,
                      mergeList: value?.mergeList,
                      moveFrom: value?.moveFrom,
                      mainTable: value?.mainTable,
                      customerName: value?.customerName,
                      createdTime: value?.createdTime,
                      reservationTime: value?.reservationTime,
                      openedTime: value?.openedTime,
                      endTime: value?.endTime,
                    }}
                    type={value?.type}
                    isSelected={value.tableID === tableSeletected}
                    isReservedMode={isReservedMode}
                    isMergeTableMode={isMergeTableMode}
                    isMergeSelected={
                      value.tableID !== tableSeletected &&
                      tableMergeSelectedList.some(
                        (table) => table.tableID === value.tableID
                      )
                    }
                    isMoveTableMode={isMoveMode}
                    isMoveSelected={
                      isMoveMode &&
                      value.tableID &&
                      value.tableID === tableMoveSelected?.tableID
                    }
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <ModalTableOpenConfirm
        modalOpenObj={{
          modalOpen: modalTableOpenCfOpen,
          setModalOpen: setModalTableOpenCfOpen,
        }}
        submitFunc={openTable}
        info={{
          tableNo: tableSeletected
            ? getTableDataById(tableSeletected)?.tableNo
            : "",
        }}
        table={getTableDataById(tableSeletected)}
      />

      <ModalTableEventMode
        modalOpenObj={{
          modalOpen: modalTableMergeCancelOpen,
          setModalOpen: setModalTableMergeCancelOpen,
        }}
        info={{
          headText: "คุณต้องการยกเลิกการรวมโต๊ะ",
          selectTableNo: tableSeletected
            ? getTableDataById(tableSeletected)?.tableNo
            : "",
          targetList: tableMergeSelectedList
            .map((table) => table.tableNo)
            .join(", "),
        }}
        onConfirm={() => {
          setTableMergeSelectedList([]);
          setIsMergeTableMode(false);
          setModalTableMergeCancelOpen(false);
        }}
      />

      <ModalTableEventMode
        modalOpenObj={{
          modalOpen: modalTableMergeCfOpen,
          setModalOpen: setModalTableMergeCfOpen,
        }}
        info={{
          headText: "คุณต้องการยืนยันการรวมโต๊ะ",
          selectTableNo: tableSeletected
            ? getTableDataById(tableSeletected)?.tableNo
            : "",
          targetList: tableMergeSelectedList
            .map((table) => table.tableNo)
            .join(", "),
        }}
        tableMergeSelectedListObj={{
          tableMergeSelectedList: tableMergeSelectedList,
          setTableMergeSelectedList: setTableMergeSelectedList,
        }}
        onConfirm={async () => {
          await mergeTable();
        }}
      />

      <ModalTableEventMode
        modalOpenObj={{
          modalOpen: modalTableMoveCancelOpen,
          setModalOpen: setModalTableMoveCancelOpen,
        }}
        info={{
          headText: "คุณต้องการยกเลิกการย้ายโต๊ะ",
          selectTableNo: tableSeletected
            ? getTableDataById(tableSeletected)?.tableNo
            : "",
          targetList: tableMoveSelected?.tableNo || "",
        }}
        onConfirm={async () => {
          setTableMoveSelected(undefined);
          setIsMoveMode(false);
          setModalTableMoveCancelOpen(false);
        }}
      />

      <ModalTableEventMode
        modalOpenObj={{
          modalOpen: modalTableMoveCfOpen,
          setModalOpen: setModalTableMoveCfOpen,
        }}
        info={{
          headText: "คุณต้องการยืนยันการย้ายโต๊ะ",
          selectTableNo: tableSeletected
            ? getTableDataById(tableSeletected)?.tableNo
            : "",
          targetList: tableMoveSelected?.tableNo || "",
        }}
        onConfirm={async () => {
          await moveTable();
          setTableSeletected(undefined);
          setTableMoveSelected(undefined);
          setIsMoveMode(false);
          setModalTableMoveCfOpen(false);
        }}
      />

      <ShowTableDetail
        isDetailModeObj={{
          isDetailMode: isDetailMode,
          setIsDetailMode,
        }}
        currentTableOrder={getTableDataById(tableSeletected)}
        currentZoneName={
          tableZoneBtnList.find((zone) => zone.id === currentZone)?.name || "-"
        }
      />

      {/* [qr] Static QR print — grid (batch) or receipt (single) */}
      <ModalQrTablePrint
        isOpen={modalQrPrintOpen}
        mode={qrPrintTables.length > 1 ? "grid" : "receipt"}
        tables={qrPrintTables.length > 1 ? qrPrintTables : undefined}
        table={qrPrintTables.length === 1 ? qrPrintTables[0] : undefined}
        zoneId={currentZone}
        zoneName={tableZoneBtnList.find((zone) => zone.id === currentZone)?.name || ""}
        slug={businessSlug}
        onPrintComplete={() => setModalQrPrintOpen(false)}
      />

      {/* [qr] Dynamic session QR print — reads bill from state.bill.data like ReceiptPrintPage */}
      <ModalQrTablePrint
        isOpen={!!qrDynamic}
        mode="dynamic"
        slug={businessSlug}
        zoneName={tableZoneBtnList.find((zone) => zone.id === currentZone)?.name || ""}
        tableName={qrDynamic?.tableName || ""}
        qrToken={qrDynamic?.qrToken}
        qrUrl={qrDynamic?.qrUrl}
        expiresAt={qrDynamic?.expiresAt}
        onPrintComplete={() => setQrDynamic(null)}
      />
    </div>
  );
}
